
const IfElseComp = ({cond, trueComp, falseComp, children}) => {
    if (cond) {
        return trueComp;
    } else {
        return falseComp;
    }
}

export default IfElseComp;
